import { useEffect, useState } from 'react';
import {
    asyncGetSwitch,
    asyncGetSwitchHistorical,
} from '../../../../../services/switch.service';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Switch,
    SwitchHistorical,
} from '../../../../../shared/types/modules/switch';
import { SWITCH } from '../../../../../routes/paths';

export const useSwitchDetail = (showHistorical: boolean) => {
    const navigate = useNavigate();
    const { idSwitch } = useParams();
    const [loading, setLoading] = useState(false);
    const [switchDetail, setSwitchDetail] = useState<Switch>();
    const [switchHistorical, setSwitchHistorical] =
        useState<SwitchHistorical[]>();

    useEffect(() => {
        if (Boolean(idSwitch?.trim())) {
            setLoading(true);
            asyncGetSwitch(idSwitch?.trim())
                .then((res) => {
                    if (res) setSwitchDetail(res);
                    else navigate(SWITCH);
                })
                .finally(() => setLoading(false));
        }
    }, [idSwitch]);

    useEffect(() => {
        if (Boolean(idSwitch?.trim())) {
            setLoading(true);
            asyncGetSwitchHistorical(idSwitch?.trim())
                .then((resp) => {
                    if (resp) setSwitchHistorical(resp);
                    else navigate(SWITCH);
                })
                .finally(() => setLoading(false));
        }
    }, [idSwitch, showHistorical]);

    return { loading, switchDetail, switchHistorical };
};
